const config = {
  entity_short_name: "Alta",
  baseurl_override: undefined,
  email: {
    generic: "enquiry@alta.exchange",
    doNotReply: "no-reply@alta.exchange",
    operations: "operations@alta.exchange",
    cs: "cs@alta.exchange",
    clientSuccess: "clientsuccess@alta.exchange",
    settlements: {
      sg: "settlements@alta.exchange",
      my: "settlement.my@alta.exchange",
    },
    onboarding: "investor.onboarding@alta.exchange",
    productSupport: "product+support@alta.exchange",
    kyc: {
      my: "ecf-kyc@alta.exchange",
    },
    compliance: "compliance@alta.exchange",
    internal: {
      legalAndCompliance: "lc@alta.exchange",
      compliance: "prime-kyc@alta.exchange",
      pcm: "pcm@alta.exchange",
    },
    trustee: "operation@pacifictrustees.com",
  },
  entity_legal_url: "https://alta.exchange/terms-of-use",
  entity_help_url: "https://help.alta.exchange/investor-resources",
  entity_otp_help_url: "https://help.alta.exchange/investor-resources/i-did-not-receive-my-otp-email",
  branding: {
    asset: {
      logoPublicUrl:
        "https://dealroom-main.s3.ap-southeast-1.amazonaws.com/2022/8/epe8piblpy-1664349013995.png",
    },
    fontSize: {
      "2xs": "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "2rem",
      "4xl": "2.25rem",
    },
    colors: {
      brand: {
        primary: "#40c1ac",
        "primary-hover": "#2c5862",
        secondary: "#00313c",
        "secondary-hover": "#17434d",
        accent: {
          1: "#c1ecf7",
          2: "#eee9d8",
          3: "#dceec0",
          4: "#d4cdff",
        },
        email: "#00313c",
        "platform-background": "#00313c",
      },
      white: "#ffffff",
      black: "#161618",
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
      },
      forest: {
        50: "#fcfdfd",
        100: "#f5fbfc",
        200: "#daeaed",
        300: "#bdd4d9",
        400: "#90b3bb",
        500: "#2c5862",
        600: "#17434d",
        700: "#073a45",
        800: "#00313c",
        900: "#05262e",
      },
      red: {
        50: "#fffafa",
        100: "#fff0f1",
        200: "#f5d5d8",
        300: "#f5b5ba",
        400: "#f16974",
        600: "#af1623",
        800: "#681219",
        500: "#d93f4c",
        700: "#8c232c",
        900: "#570f15",
      },
      orange: {
        50: "#fffaf5",
        100: "#fff7ed",
        200: "#ffeedb",
        300: "#fed6a8",
        400: "#ffb057",
        500: "#f79a3e",
        600: "#ed8f1c",
        700: "#ad5918",
        800: "#703815",
        900: "#5e2f12",
      },
      green: {
        50: "#f8fcfb",
        100: "#edf8f4",
        200: "#d1e8df",
        300: "#aecfc2",
        400: "#5eae91",
        500: "#228f67",
        600: "#038153",
        700: "#186146",
        800: "#0b3b29",
        900: "#092f21",
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
      },
    },
  },

  allowViewOnlyInternalLogins: true,
  internalUserDomain: "alta.exchange",

  services: {
    platforms: ["SG", "MY"],
    "a-prime": {
      enabled: true,
      intercom: true,
      showOverlaysOnAPrimeAuthPage: true,
      integrations: {
        calendly: {
          enabled: true,
        },
        googleAds: {
          enabled: true,
        },
        googleAnalytics: {
          enabled: true,
        },
        googleTagManager: {
          enabled: true,
        },
        hubspot: {
          enabled: true,
        },
        linkedinInsights: {
          enabled: true,
        },
        recaptcha: {
          enabled: true,
        },
        segment: {
          enabled: true,
        },
        sentry: {
          enabled: true,
        },
        singpass: {
          enabled: true,
        },
      },
      disclaimer: {
        copy: `**Risk Warning & Disclaimers** Alta Alternative Investments Pte. Ltd. ("Alta AI") is regulated by the Monetary Authority of Singapore (“MAS”) as the holder of a capital markets services licence for dealing in securities and as an exempt financial advisor in relation to securities and collective investment schemes in Singapore. AltaX Pte. Ltd. is regulated by the MAS as a recognised market operator in Singapore (“AltaX”). Alta Sdn. Bhd. (formerly known as Fundnel Technologies Sdn. Bhd. is regulated by (2) SC as a Recognised Market Operator (ECF) under the Capital Markets Services Act 2007 in Malaysia. Alta Sdn. Bhd. ("Alta MY") is regulated in Malaysia by the Securities Commission Malaysia as a recognised market operator for equity crowdfunding. This website has not been reviewed by the MAS or SC and has been prepared solely for informational purposes and may not be reproduced or redistributed without our express permission to any other person. This website is owned and managed by Alta AI, including Alta and AltaX. The delivery and contents of this website do not constitute a recommendation, offer, or solicitation of an offer to enter into any contract or agreement to provide any investment services or to apply for or buy any securities, or to effect or conclude any transaction of any kind whatsoever in any jurisdiction to any person to whom it is unlawful to make such an invitation or solicitation in such jurisdiction. This website and its contents are not an advertisement calling attention to an offer or intention to offer any investment. Alta AI, including Alta, AltaX, Alta MY, and all their related entities do not make any assurance, representation, warranty, or other guarantees as to the completeness or accuracy of the contents of this website, and none of them shall be liable for any loss whatsoever arising from any use of or reliance on the same. Investing in private companies (particularly start-ups and early stage) carries significant risks including illiquidity, loss of capital, rarity of dividends, and dilution, and should not be undertaken without professional advice or a full understanding of the risks involved. Investors are advised to read and understand the details of a deal or investment and seek their own professional advice before investing, and to consider the fees, charges and costs involved in making an investment. None of the information on this website has, and shall not be construed as having, any regard to the particular situation of any particular person including the investment objectives, financial position, or needs of any particular person.`,
      },
      unitedStatesPersonDefinitionLink:
        "https://help.alta.exchange/investor-resources/what-is-a-united-states-person",
      politicallyExposedPersonDefinitionLink:
        "https://help.alta.exchange/investor-resources/what-does-a-politically-exposed-person-pep-mean",
      usPersonDefinitionLink:
        "https://help.alta.exchange/investor-resources/what-is-a-united-states-person",
      riskDisclosure: {
        link: "https://alta.exchange/risk-disclosures",
      },
      features: {
        ecf: {
          enabled: true,
        },
        hardcodeHamiltonHoldings: {
          enabled: true,
        },
        marketingOptIn: {
          enabled: true,
        },
        paymentRef: {
          enabled: false,
        },
        pricingGraph: {
          enabled: true,
        },
        primaryFirmDeal: {
          enabled: true,
        },
        topPicks: {
          enabled: true,
        },
        raiseCapital: {
          enabled: true,
          externalUrl: "https://fundraise.alta.exchange/",
        },
        portfolio: {
          enabled: true,
          orderStatusUrl: "https://help.alta.exchange/order-statuses-sg",
        },
        mmf: {
          enabled: true,
          externalUrl:
            "https://help.alta.exchange/investor-resources/alta-cash-solutions",
          yield: "4.2%",
        },
        singpassNoa: {
          // NOTE: true means SHOW, false means HIDE
          enabled: true,
        },
        idenfy: {
          enabled: true,
        },
        partner: {
          enabled: true,
        },
      },
    },
    atlas: {
      authentication: {
        provider: "google",
        superAdminEmails: [
          "khairul.norady@alta.exchange",
          "divya.kunnath@alta.exchange",
          "eunice.chuah@alta.exchange",
          "hansen.wong@alta.exchange",
        ],
      },
      features: {
        superadmin: {
          enabled: false,
          modules: {
            beneficiaryOwner: false,
            singpass: false,
            topPicks: false,
            "finance.bankLedger": false,
            "finance.withdrawalApproval": false,
            "investor.cashBalance": false,
            "product.assets.listOnExchange": false,
            "product.deals.dealFee": false,
            "product.deals.investmentConfig": false,
            "product.deals.updateGraph": false,
            "product.deals.exchangeCode": true,
            "product.deals.partner": false,
            mmf: false,
          },
          formOptions: {
            deals: {
              listingType: {
                omit: ["secondary"],
              },
              orderType: {
                omit: ["firm_order"],
              },
              platform: {
                omit: ["MY"],
              },
            },
            orders: {
              createType: {
                omit: ["issue"],
              },
            },
          },
        },
        idenfy: {
          enabled: true,
        },
        backendOrdersExport: {
          enabled: false,
        },
      },
    },
  },

  paymentMethod: {
    displayPaymentMethod: true,
    sendPaymentMethodEmail: true,
    paymentMethodText: "Bank transfer or Paynow",
    paymentMethodLink: "https://help.alta.exchange/how-do-i-fund-my-account",
    primaryFirmPaymentInformation: {
      accountName: "AltaX Pte. Ltd.",
      uen: "201902743NTBA",
      accountNumber: "072-918536-0",
      bankName: "DBS Bank Ltd",
      bankCode: "7171",
      branchName: "Raffles Place",
      branchCode: "072",
      swiftCode: "DBSSSGSGXXX",
      paynowQRUrl:
        "https://storage.googleapis.com/dealroom-main/qr/paynow_08_2024.png",
    },
  },

  bankInformation: {
    sg: {
      accountName: "AltaX Pte. Ltd.",
      uen: "201902743NTBA",
      accountNumber: "072-918536-0",
      bankName: "DBS Bank Ltd",
      bankCode: "7171",
      branchName: "Raffles Place",
      branchCode: "072",
      swiftCode: "DBSSSGSGXXX",
      paynowQRUrl:
        "https://storage.googleapis.com/dealroom-main/qr/paynow_08_2024.png",
    },
    my: {
      beneficiaryName: "Pacific Trustees Berhad for Alta Sdn. Bhd.",
      beneficiaryAddress:
        "Unit A-9-8, 9th Floor, Megan Avenue 1, No 189 Jalan Tun Razak, 50400 Kuala Lumpur, Malaysia",
      bankName: "United Overseas Bank (Malaysia) Bhd",
      bankBranch: "Medan Pasar",
      swiftCode: "UOVBMYKL",
      accountType: "Current A/C",
      accountNumber: "256-302-264-9",
      bankCountryCity: "Malaysia, Kuala Lumpur",
      bankAddress:
        "United Overseas Bank (Malaysia) Bhd, 10-12, Medan Pasar, Bangunan UOB, 50050 Kuala Lumpur, Malaysia",
    },
  },
  custodySyncTncType: "sg-brokerage-and-custody-tnc",
};

export default config;
